//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconStatusStop(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M19.0701 4.93C15.1601 1.02 8.83012 1.02 4.92012 4.93C1.02012 8.83 1.02012 15.17 4.92012 19.07C8.83012 22.98 15.1601 22.98 19.0701 19.07C22.9801 15.17 22.9801 8.83 19.0701 4.93ZM17.6601 17.66C14.5301 20.78 9.47012 20.79 6.34012 17.66C3.22012 14.54 3.22012 9.47 6.34012 6.35C9.47012 3.23 14.5301 3.22 17.6601 6.35C20.7801 9.46 20.7801 14.54 17.6601 17.66Z" fill="currentColor" /><path d="M8 8H16V16H8V8Z" fill="currentColor" /></svg>;
}
export default IconStatusStop;